import React, { useState, useEffect } from 'react';
import {
  OfferSectionContainer,
  OfferSectionHeader,
  OfferSectionBody,
  OfferTable,
  EventCreatorProfile,
  EventUserProfile,
  EventActionProfile,
  FilterWrapper,
  TitleWrapper,
  PaginationWrapper
} from './styles';
import { Pagination } from '../Pagination';
import { useTheme } from 'styled-components';
import { EmptyActivityIcon, HammerIcon, ActionCloseIcon, ActionCheckIcon } from '../SvgIcons';
import { useGlobal } from '../../../contexts/GlobalContext';
import { useCustomWallet } from '../../../contexts/WalletContext';
import { useNavigate } from 'react-router-dom';
import eventCreatorAvatar from '../../../assets/images/EventCreatorAvatar.png';
import useToast from '../../../hooks/useToast';
import GradientButton from '../GradientButton';
import { NOTIFI_TYPE } from '../../../global/const';
import { useContract } from '../../../contexts/ContractContext'

const AuctionSection = (props) => {
  const {
    handleActiveSection,
    userAddress
  } = props

  const theme = useTheme();
  const { toastInfo, toastSuccess, toastError, showLoading, hideLoading } = useToast();
  const [offerListRows, setOfferListRows] = useState([])
  const navigate = useNavigate()
  const { getWalletAddressBySessionKey } = useCustomWallet()
  const [auctionList, setAuctionList] = useState([])
  const { removeBid } = useContract();

  const { invokeServer } = useGlobal();

  const [methodType, setMethodType] = useState('all')
  const [paginationProps, setPaginationProps] = useState({
    page_size: 10,
    current_page: 1
  })

  const filterList = [
    { key: 'all', name: 'ALL' },
    { key: NOTIFI_TYPE.BID_MADE, name: 'BIDS MADE' },
    { key: NOTIFI_TYPE.BID_RECEIVED, name: 'BIDS RECEIVED' }
  ]

  const handleChangePage = (pageNumber) => {
    getAuctionList(pageNumber, 10)
  }

  useEffect(() => {
    getAuctionList(paginationProps.current_page, 10);
  }, [methodType])

  const getAuctionList = (page, page_size) => {
    let params = `address=${getWalletAddressBySessionKey()}&page=${page}&page_size=${page_size}`
    if (methodType !== 'all') params = `${params}&method=${methodType}`

    invokeServer('get', `/api/bid?${params}`)
      .then(r => {
        if (r.data.items !== undefined && JSON.stringify(r.data.items) !== JSON.stringify(auctionList)) {
          setAuctionList(t => r.data.items);
          setPaginationProps(r.data.pagination)
        }
      })
      .catch(err => {
        console.log(`${err.message}`);
      })
  }

  const handleOpenCollection = (item) => {
    navigate(`/products/${item.collectionAddress}/${item.nftId}/${item.saleId}/bid`)
  }

  const renderItemField = (item) => {
    let nftAvatar = item?.nftImage || eventCreatorAvatar
    let nftName = item?.nftTitle
    let creator = item?.sellerName || ''

    return (
      <EventCreatorProfile>
        <img src={nftAvatar} alt='nft' />
        <div>
          <div className="title">{creator}</div>
          <div className="value" onClick={() => handleOpenCollection(item)}>{nftName}</div>
        </div>
      </EventCreatorProfile>
    )
  }

  const renderPriceField = (activity) => {
    switch (activity.paymentName) {
      case 'HyperX':
        return (
          <div className="price-div">
            <img src={theme.images.chainTokenIcon} alt='hyperX' />
            <div>{activity?.price}</div>
          </div>
        )
      case 'BNB':
        return (
          <div className="price-div">
            <img src={theme.images.binanceTokenIcon} alt='bnb' />
            <div>{activity?.price}</div>
          </div>
        )
      case 'BUSD':
        return (
          <div className="price-div">
            <img src={theme.images.binanceUsdIcon} alt='busd' />
            <div>{activity?.price}</div>
          </div>
        )
      default:
        return (
          <div className="price-div">
            <div>{activity.basePrice} {activity.paymentName}</div>
          </div>
        )
    }
  }

  const renderActions = (item) => {
    return (
      <EventActionProfile>
        <div onClick={() => handleRemoveAuction(item)}><ActionCloseIcon /></div>
      </EventActionProfile>
    )
  }

  const renderType = (type) => {
    if (type === 2) return 'Bid made'
    if (type === 3) return 'Bid received'
    return ''
  }

  useEffect(() => {
    if (auctionList.length > 0) {
      setOfferListRows(allRows =>
        auctionList.map(item => {
          return (
            <tr key={item._id}>
              <td>{renderType(item?.eventType)}</td>
              <td>{renderItemField(item)}</td>
              <td>{renderPriceField(item)}</td>
              <td>1</td>
              <td>{item.timeSpan}</td>
              <td>{item.eventType === 2 && renderActions(item)}</td>
            </tr>
          )
        })
      )
    } else {
      setOfferListRows(allRows => []);
    }
  }, [auctionList])

  const handleRemoveAuction = async (item) => {
    showLoading(`Removing your Bid(${item.saleId})...`);

    let tx = await removeBid(item.saleId);
    if (tx !== undefined) {
      console.log('====', tx.events.BidRemoved.returnValues);

      await invokeServer('post', '/api/bid/remove', {id: item._id})
      .then(r => {
        console.log(r)
        if (r.data.result === 1) {
          toastSuccess('Auction', r.data.msg)
          const updatedListItems = auctionList.filter(list => list._id !== item._id)
          setAuctionList(updatedListItems)
        } else {
          toastInfo('Auction', r.data.msg)
        }
      })
      .catch(err => {
        console.log(`${err.message}`);
        toastError('Auction', err.message)
      })
    }

    hideLoading();
  }

  return (
    <OfferSectionContainer>
      <OfferSectionHeader>
        <TitleWrapper>
          <HammerIcon />
          <div className="header-text">Auction</div>
        </TitleWrapper>
        <FilterWrapper>
          {filterList.map(item => (
            <GradientButton
              key={item.key}
              isNoPadding
              width='140px'
              height='40px'
              label={item.name}
              isBlackMode={methodType !== item.key}
              isDarkMode={methodType !== item.key}
              handleClick={() => setMethodType(item.key)}
            />
          ))}
        </FilterWrapper>
      </OfferSectionHeader>
      <OfferSectionBody>
        <OfferTable>
          <table>
            <thead>
              <tr>
                <th>Event</th>
                <th>Items</th>
                <th>Price</th>
                <th>Quantity</th>
                <th>Expires in / Time left</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {offerListRows.length > 0 ? offerListRows : (
                <tr>
                  <td colSpan={8} style={{ paddingTop: '100px' }}>
                    <div className="no-result">
                      <EmptyActivityIcon />
                      <div className="empty-text">There Are No auctions Yet</div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </OfferTable>
        <PaginationWrapper>
          <Pagination
            currentPage={paginationProps?.current_page}
            totalPages={paginationProps?.total_pages}
            totalItems={paginationProps?.total}
            handleChangePage={handleChangePage}
          />
        </PaginationWrapper>
      </OfferSectionBody>
    </OfferSectionContainer>
  )
}

export default AuctionSection;
